import * as React from "react";
import { useEffect, useState } from "react";
import "./TrainingTab.component.css";
import { trainingDebugService } from "../../../services/training-debug.service";
import { TrainingStageTab } from "./training-tab-content/TrainingStageTab.component";
import { TrainingObjectTab } from "./training-tab-content/TrainingObjectTab.component";
import { TrainingEventTab } from "./training-tab-content/TrainingEventTab.component";
export const TrainingTab = () => {
    const [activeSubTab, setActiveSubTab] = useState("stage");
    const [snapshot, setSnapshot] = useState(trainingDebugService.getSnapshot());
    useEffect(() => {
        const update = () => {
            setSnapshot(trainingDebugService.getSnapshot());
        };
        trainingDebugService.onChangedDelegate.add(update);
        return () => {
            trainingDebugService.onChangedDelegate.remove(update);
        };
    }, []);
    if (!snapshot.hasToml) {
        return (React.createElement("div", { className: "training-tab training-tab-empty" },
            React.createElement("div", { className: "training-tab-empty-text" }, "NO TOML FOUND")));
    }
    return (React.createElement("div", { className: "training-tab" },
        React.createElement("div", { className: "training-subtabs" },
            React.createElement("button", { className: activeSubTab === "stage" ? "active" : "", onClick: () => {
                    setActiveSubTab("stage");
                } }, "Stage"),
            React.createElement("button", { className: activeSubTab === "object" ? "active" : "", onClick: () => {
                    setActiveSubTab("object");
                } }, "Object"),
            React.createElement("button", { className: activeSubTab === "event" ? "active" : "", onClick: () => {
                    setActiveSubTab("event");
                } }, "Event")),
        React.createElement("div", { className: "training-subtab-content" },
            activeSubTab === "stage" && (React.createElement(TrainingStageTab, { scenario: snapshot.scenario, currentStageId: snapshot.currentStageId, debugVersion: snapshot.version })),
            activeSubTab === "object" && (React.createElement(TrainingObjectTab, { scenario: snapshot.scenario, debugVersion: snapshot.version })),
            activeSubTab === "event" && (React.createElement(TrainingEventTab, null)))));
};
